module.exports = __webpack_public_path__ + "static/img/erweima.7419cf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/erweima.jpg
// module id = Y6K9
// module chunks = 2